//Creates new Plant and assigns ID and type
export const createPlant = (data) => {
    //data = {id, type}
    return { type: "CREATE_PLANT", payload: data}
}

export const setPlantHeld = (data) => {
    //data = {id, inScene}
    return { type: "SET_PLANT_HELD", payload: data}
}

//Set whether the pipette controls are displayed or not
export const setPlantControlVisibility = (data) => {
    //data = {id, animatingOut}
    return { type: "SET_PLANT_CONTROLS_VISIBLE", payload: data}
  }

  export const setPlantsInScene = data => {
    //data = {type, inScene}
    return { type: "SET_PLANTS_IN_SCENE", payload: data };
  };